module.exports = __webpack_public_path__ + "img/bl-bottom.20fae1f9.png";